import React from 'reactn';
import { graphql, StaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Box, Center, Link, SimpleGrid } from '@chakra-ui/react';

const InstagramFeed = () => (

    <StaticQuery
        query={graphql`
      query InstagramPosts {
        allInstaNode(sort: {fields: timestamp, order: DESC}, limit: 12) {
          edges {
            node {
              id
              caption 
              localFile {
                childImageSharp {
                    gatsbyImageData(
                        width: 300
                        aspectRatio: 1
                        placeholder: BLURRED
                        formats: [AUTO, WEBP, AVIF]
                      )
                }
              }
            }
          }
        }
      }
    `}
        render={(data) => (
            <Center>
            <SimpleGrid columns={[2,2,4,4]} spacing={3}>
                {
                    data.allInstaNode.edges.map((item, i) => {
                        const image = getImage(item.node.localFile)
                        const caption = getCaption(item.node.caption, i)
                        return (
                            item.node.localFile ? (
                                <Box key={i} >
                                    <Box  >
                                        <Link isExternal rel="noopener noreferrer"
                                            target="_blank"
                                            alt={ caption }
                                            href={`https://instagram.com/p/${item.node.id}`}>
                                            <GatsbyImage image={image} alt={caption} />
                                        </Link>
                                    </Box>
                                </Box>
                            ) : (<div key={i}></div>)
                        )
                    })
                }
            </SimpleGrid>
            </Center>
        )}
    />
);

function getCaption(caption, i) {
    return caption ? caption.replace(/[^a-zA-Z\. ]+/g, '') : "Instagram Post " + i
}

export default InstagramFeed;

